import api from "../api/base-api"
import {AB_TESTS} from "../../components/Utils/CommonUtils";

const profileApi = api.injectEndpoints({
        endpoints: (build) => ({

            getProfileCampaigns: build.query({
                query: ({userId,env}) => {
                    return {
                        url: `/admin/campaign/profile/get?environment=${env}&userId=${userId}`,
                        env: env
                    }
                },
                providesTags: (result, error, arg) => {
                    return ['profileCampaign']
                },
                keepUnusedDataFor: 0
            }),


            updateProfileCampaigns: build.mutation({
                query: ({
                            userId,
                            offerId,
                            env,
                            startSec,
                            endSec,
                            mainPhaseFromSec,
                            mainPhaseTillSec
                        }) => {
                    return {
                        url: `/admin/campaign/profile/update?userId=${userId}&offerId=${offerId}&environment=${env}&startSec=${startSec}&endSec=${endSec}&mainPhaseFromSec=${mainPhaseFromSec}&mainPhaseTillSec=${mainPhaseTillSec}`,
                        env: env,
                        method: "POST",
                    }
                },
                invalidatesTags: ['profileCampaign']

            }),
            removeProfileCampaigns: build.mutation({
                query: ({userId, offerId, env}) => {
                    return {
                        url: `/admin/campaign/profile/remove?environment=${env}&userId=${userId}&offerId=${offerId}`,
                        method: "POST",
                        env: env
                    }
                },
                invalidatesTags: ['profileCampaign']

            }),
            restartProfileCampaigns: build.mutation({
                query: ({userId, offerId, env}) => {
                    return {
                        url: `/admin/campaign/profile/restart?environment=${env}&userId=${userId}&offerId=${offerId}`,
                        method: "POST",
                        env: env
                    }
                },
                invalidatesTags: ['profileCampaign']

            }),

            addProfileCampaigns: build.mutation({
                query: ({userId, offerId, env}) => {
                    return {
                        url: `/admin/campaign/profile/add?environment=${env}&userId=${userId}&offerId=${offerId}`,
                        method: "POST",
                        env: env
                    }
                },
                invalidatesTags: ['profileCampaign']

            }),


            getProfileAbtests: build.query({
                query: ({userId,env}) => {
                    return {
                        url: `/admin/abtest/profile/get?environment=${env}&userId=${userId}`,
                        env: env
                    }
                },
                providesTags: (result, error, arg) => {
                    return ['profileAbtests']
                },
                extraOptions : {
                    type: AB_TESTS
                },
                keepUnusedDataFor: 0
            }),

            updateProfileAbtests: build.mutation({
                query: ({
                            userId,
                            abTestId,
                            env,
                            startSec,
                            endSec,
                            mainPhaseFromSec,
                            mainPhaseTillSec,
                            cohort
                }) => {
                    return {
                        url: `/admin/abtest/profile/update?cohortId=${cohort}&userId=${userId}&abTestId=${abTestId}&environment=${env}&startSec=${startSec}&endSec=${endSec}&mainPhaseFromSec=${mainPhaseFromSec}&mainPhaseTillSec=${mainPhaseTillSec}`,
                        method: "POST",
                        env: env
                    }
                },
                extraOptions : {
                    type: AB_TESTS
                },
                invalidatesTags: ['profileAbtests']

            }),
            removeProfileAbtests: build.mutation({
                query: ({userId, abTestId, env}) => {
                    return {
                        url: `/admin/abtest/profile/remove?environment=${env}&userId=${userId}&abTestId=${abTestId}`,
                        method: "POST",
                        env: env
                    }
                },
                extraOptions : {
                    type: AB_TESTS
                },
                invalidatesTags: ['profileAbtests']

            }),
            restartProfileAbtests: build.mutation({
                query: ({userId, abTestId, env}) => {
                    return {
                        url: `/admin/abtest/profile/restart?environment=${env}&userId=${userId}&abTestId=${abTestId}`,
                        method: "POST",
                        env: env
                    }
                },
                extraOptions : {
                    type: AB_TESTS
                },
                invalidatesTags: ['profileAbtests']

            }),

            addProfileAbtests: build.mutation({
                query: ({userId, abTestId, cohortId, env}) => {
                    return {
                        url: `/admin/abtest/profile/add?environment=${env}&userId=${userId}&abTestId=${abTestId}&cohortId=${cohortId}`,
                        method: "POST",
                        env: env
                    }
                },
                extraOptions : {
                    type: AB_TESTS
                },
                invalidatesTags: ['profileAbtests']

            }),
        }),
    }
)

export const {
    useGetProfileCampaignsQuery,
    useAddProfileCampaignsMutation,
    useUpdateProfileCampaignsMutation,
    useRemoveProfileCampaignsMutation,
    useRestartProfileCampaignsMutation,

    useGetProfileAbtestsQuery,
    useAddProfileAbtestsMutation,
    useUpdateProfileAbtestsMutation,
    useRemoveProfileAbtestsMutation,
    useRestartProfileAbtestsMutation
} = profileApi;